import { Alert } from '@hakimo-ui/shared/ui-base';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import MultiCamGrid from './MultiCamGrid';
import { MultiCamTab, gridOrderAtom, gridSizeOverrideAtom } from '../../state';
import useMultiCamSelection from '../../useMultiCamSelection';
import useTabCameras from './useTabCameras';

interface Props {
  tab: MultiCamTab;
  isActive: boolean;
}

export function MultiCamTabGrid({ tab, isActive }: Props) {
  const gridSizeOverride = useAtomValue(gridSizeOverrideAtom)[tab.id] ?? null;
  const setGridOrder = useSetAtom(gridOrderAtom);
  const { cameras, isFetching, isError, error } = useTabCameras(tab);
  const { removeCameras, removeGroup, removeCameraFromGroup } =
    useMultiCamSelection();

  const onReorder = useCallback(
    (orderedIds: string[]) => {
      setGridOrder((prev) => ({ ...prev, [tab.id]: orderedIds }));
    },
    [setGridOrder, tab.id]
  );

  const onRemoveCamera = (cameraId: string) => {
    if (tab.type === 'cameras') {
      removeCameras([cameraId]);
      return;
    }
    const remaining = cameras.filter((cam) => cam.id !== cameraId).length;
    if (remaining === 0) removeGroup(tab.id);
    else removeCameraFromGroup(tab.id, cameraId);
  };

  if (isError) {
    return (
      <div className="p-4">
        <Alert type="error">{error?.message}</Alert>
      </div>
    );
  }

  return (
    <MultiCamGrid
      cameras={cameras}
      override={gridSizeOverride}
      isFetching={isFetching}
      isActive={isActive}
      onRemoveCamera={onRemoveCamera}
      onReorder={onReorder}
    />
  );
}

export default MultiCamTabGrid;
